export default __webpack_public_path__ + "static/media/pets-fight.1dc9cb3a.jpg";